import { styled } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox } from '@youscience/core';

export const StyledJustifiedBox = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  alignSelf: 'stretch',
  alignItems: 'center',
  alignContent: 'flex-start',
  justifyContent: 'space-between',
  flexDirection: 'row',

  [theme.breakpoints.down('md')]: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
}));

export const StyledCounselor = styled(CoreBox)(() => ({
  display: 'flex',
  padding: '1rem 0rem',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '1rem',
  alignSelf: 'stretch',
  borderTop: `1px solid ${coreThemeColors.grey[300]}`,
  borderBottom: `1px solid ${coreThemeColors.grey[300]}`,
}));

export const StyledCounselorReports = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.5rem',
  alignSelf: 'stretch',
}));
